import { get } from 'svelte/store'

import {
  player,
  isPlayer,
  updatePlayerHand,
  topDeck,
  topDiscard,
  addToDiscard,
  removeFromDiscard,
  removeFromDeck,
  revealDeckCard,
} from '../../stores/cards'
import {
  targetCard,
  sourceCard,
  cardsInitialized,
  zoomDiscard,
  zoomDeck,
  deckCardVisible,
  deckSelected,
  discardSelected,
  handOver,
} from '../../stores/cardPLay'

import { checkForSeries } from '../services'


function playerHandClick(card, index) {
  if (!isPlayer()) return
  
  if (card.displayClass === 'transparent' || targetCard()) return

  let initialized = cardsInitialized()
  if (initialized < 2) {
    if (card.displayClass === 'hidden') {
      updatePlayerHand(index, card)
      initialized++
      cardsInitialized(initialized)
    }
    return
  }

  if (!sourceCard()) return

  if (targetCard()) return

  card.zoom = true

  updatePlayerHand(index, card)
  targetCard(card)
}

function playerDiscardClick() {
  if (!isPlayer()) return

  let tCard = targetCard()
  let sCard = sourceCard()

  if (deckSelected()) {
    if (tCard) {
      tCard.zoom = false
      updatePlayerHand(tCard.handIndex, tCard)
      sCard.handIndex = tCard.handIndex
      sCard.displayClass = 'visible'
      updatePlayerHand(sCard.handIndex, sCard)
      checkForSeries(0, get(player), sCard.handIndex)
      addToDiscard(tCard)
    } else {
      addToDiscard(sCard)
    }
    zoomDeck(false)
    removeFromDeck()
  } else if (tCard) {
    tCard.zoom = false
    updatePlayerHand(tCard.handIndex, tCard)
    sCard.handIndex = tCard.handIndex
    removeFromDiscard()
    updatePlayerHand(sCard.handIndex, sCard)
    checkForSeries(0, get(player), sCard.handIndex)
    addToDiscard(tCard)
  }

  zoomDiscard(false)

}

function playerDeckClick() {
  if (!isPlayer()) return

  if (cardsInitialized() < 2) return

  let sCard = sourceCard()
  if (sCard) return

  sCard = topDeck()
  sCard.displayClass = 'visible'
  sourceCard(sCard)
  revealDeckCard()

  deckCardVisible(true)
  deckSelected(true)
  discardSelected(false)
  zoomDeck(true)
}

export { playerHandClick, playerDiscardClick, playerDeckClick }
